import { DayPilot } from "daypilot-pro-angular";
import { Actor } from "../../model/actor";

export class ActivityEvent {

  constructor(
    public dirtyActor: boolean,
    public dirtyActivity: boolean,
    public comment: string,
    public startLocation: string,
    public endLocation: string,
    public selectedResourceId: string,
    public selectedUserMappingId: string,
    public startTime: string,
    public newStart: DayPilot.Date,
    public duration: number,
    public billed: boolean,
    public actor: Actor,
    public type: string) {

  }

}
